/**
 * The application's public name and copy.
 *
 * APP_NAME must match the OAuth consent screen's app name exactly, character
 * for character: Google's branding review compares them literally and rejects
 * the app when they differ. This is the single source of truth for the React
 * app; the static places that cannot import it (index.html, the PWA manifest in
 * vite.config.ts, and the policy pages) are held in step by
 * backend/tests/test_branding_consistency.py, which fails the suite if any of
 * them drift apart.
 */
export const APP_NAME = "Maomao's Cashier App";

/** One sentence on what the app is. Used for metadata and the home page. */
export const APP_TAGLINE = 'Simple point-of-sale software for artists and makers selling at markets and conventions.';

/** What the app does, in the operator's words. */
export const APP_FEATURES = "Manage your catalogue, ring up sales, accept PayNow payments, and track what you've sold.";

/**
 * Why the app asks for Google user data. Google's app-homepage rules require
 * the home page to state the purpose of the data request, not just the app's
 * features.
 */
export const GOOGLE_DATA_USE =
  'We ask Google only for your name and email address, and only to sign you in and open your till. Nothing is posted on your behalf and your data is never sold.';
